/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var prebid = __webpack_require__(3);

prebid.init();

var dfp = __webpack_require__(4);

dfp.init();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = {
  init: function init() {
    window.PREBID_TIMEOUT = 600;
    var currencyAdjustment = 0.7451;

    try {
      (function () {
        var rate = window.config.prebid_cur_rate;

        if (rate > 0 && rate < 100) {
          currencyAdjustment = rate;
        } else {
          throw 'Rate is not valid number';
        }
      })();
    } catch (err) {
      console.warn('Error getting exchange rate, default rate used: ' + currencyAdjustment, err);
    }

    try {
      (function () {
        var timeout = window.config.prebid_timeout;

        if (timeout > 1 && timeout < 100000) {
          window.PREBID_TIMEOUT = timeout;
        } else {
          throw 'Prebid timeout is not valid number';
        }
      })();
    } catch (err) {
      console.warn('Error getting Prebid timeout, default timeout used: ' + window.PREBID_TIMEOUT, err);
    }

    if (window.location.href.indexOf('pbjs_debug=true') > -1) {
      console.log('USD/GBP rate is: ' + currencyAdjustment);
    }

    window.pbjs = window.pbjs || {};
    window.pbjs.que = window.pbjs.que || [];

    var calculateCurrency = function calculateCurrency(bidCpm) {
      return bidCpm * currencyAdjustment;
    };

    window.pbjs.que.push(function () {
      window.pbjs.setConfig({
        consentManagement: {
          cmpApi: 'iab',
          timeout: 8000,
          allowAuctionWithoutConsent: true
        }
      });
    });
    window.pbjs.bidderSettings = {
      standard: {
        adserverTargeting: [{
          key: "hb_pb",
          val: function val(bidResponse) {
            var cpm = bidResponse.cpm;

            if (cpm < 1.00) {
              return (Math.floor(cpm * 100) / 100).toFixed(2);
            } else if (cpm < 6.00) {
              return (Math.floor(cpm * 10) / 10).toFixed(1);
            } else if (cpm < 50.00) {
              return cpm.toFixed();
            } else {
              return '50';
            }
          }
        }, {
          key: "hb_adid",
          val: function val(bidResponse) {
            return bidResponse.adId;
          }
        }, {
          key: "hb_bidder",
          val: function val(bidResponse) {
            return bidResponse.bidderCode;
          }
        }, {
          key: "hb_size",
          val: function val(bidResponse) {
            return bidResponse.size;
          }
        }]
      },

      /*brealtime: {
          bidCpmAdjustment : function (bidCpm) {
              // adjust the bid in real time before the auction takes place
              return bidCpm * .8 * currencyAdjustment;
          }
      },*/
      c1x: {
        pixelId: 1234804,
        siteId: 13255,
        adserverTargeting: [{
          key: "hb_pb",
          val: function val(bidResponse) {
            var cpm = bidResponse.cpm;

            if (cpm < 1.00) {
              return (Math.floor(cpm * 100) / 100).toFixed(2);
            } else if (cpm < 6.00) {
              return (Math.floor(cpm * 10) / 10).toFixed(1);
            } else if (cpm < 50.00) {
              return cpm.toFixed();
            } else {
              return '50';
            }
          }
        }, {
          key: "hb_adid",
          val: function val(bidResponse) {
            return bidResponse.adId;
          }
        }, {
          key: "hb_bidder",
          val: function val(bidResponse) {
            return bidResponse.bidderCode;
          }
        }, {
          key: "hb_size",
          val: function val(bidResponse) {
            return bidResponse.size;
          }
        }],
        bidCpmAdjustment: calculateCurrency
      },
      pulsepointLite: {
        bidCpmAdjustment: calculateCurrency
      },

      /*districtmDMX: {bidCpmAdjustment: calculateCurrency},*/
      defymedia: {
        bidCpmAdjustment: calculateCurrency
      },
      ix: {
        bidCpmAdjustment: calculateCurrency
      },
      appnexus: {
        bidCpmAdjustment: calculateCurrency
      },
      smartadserver: {
        bidCpmAdjustment: function bidCpmAdjustment(bidCpm) {
          // adjust the bid in real time before the auction takes place
          return bidCpm * .75 * currencyAdjustment;
        }
      },
      sharethrough: {
        bidCpmAdjustment: calculateCurrency
      },
      sovrn: {
        bidCpmAdjustment: calculateCurrency
      },
      openx: {
        bidCpmAdjustment: function bidCpmAdjustment(bidCpm) {
          // adjust the bid in real time before the auction takes place
          return bidCpm * .7 * currencyAdjustment;
        }
      },
      improvedigital: {
        bidCpmAdjustment: function bidCpmAdjustment(bidCpm) {
          // adjust the bid in real time before the auction takes place
          return bidCpm * .9 * currencyAdjustment;
        }
      }
    };
    var script = document.createElement('script');
    script.src = '/wp-content/plugins/fp-pause-helper/assets/js/prebid.js?ver=v1.12.0u2018-05-23';
    script.async = true;
    var placeToInsert = document.querySelector('script');
    placeToInsert.parentNode.insertBefore(script, placeToInsert);
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = {
  init: function init() {
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(function () {
      window.googletag.pubads().disableInitialLoad();
    });
    var gads = document.createElement('script');
    gads.async = true;
    gads.type = 'text/javascript';
    var useSSL = 'https:' == document.location.protocol;
    gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
    var node = document.getElementsByTagName('script')[0];
    node.parentNode.insertBefore(gads, node);
  }
};

/***/ })
/******/ ]);